import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function ChevronRight(props) {
  return (
    <SvgIcon viewBox="0 0 8 26" {...props}>
      <g opacity="0.5">
        <rect
          width="0.987636"
          height="14.5"
          rx="0.493818"
          transform="matrix(0.917654 -0.397382 0.448736 0.893665 0 0.392578)"
          fill="white"
        />
        <rect
          width="0.987636"
          height="14.5"
          rx="0.493818"
          transform="matrix(0.917654 0.397382 0.448736 -0.893665 0 25.6248)"
          fill="white"
        />
      </g>
    </SvgIcon>
  );
}
